import { apiEndpoints } from 'shared/model/apiEndpoints'
import { GlobalParams } from 'shared/types/QueryModel'

import { globalAPI } from 'shared/config/redux/api/global'
import { GET_NOTIFICATIONS_COUNT } from 'shared/config/redux/constants/tags'

import {
  NotificationsCountResponse,
  NotificationsResponse,
  NotificationsSeenRequest,
} from '../types'

export const notificationsApi = globalAPI.injectEndpoints({
  endpoints: (build) => ({
    notificationsCount: build.query<NotificationsCountResponse, void>({
      query: () => ({
        url: apiEndpoints.notificationsCount,
      }),
      providesTags: [GET_NOTIFICATIONS_COUNT],
    }),
    notifications: build.query<NotificationsResponse, { params: GlobalParams }>(
      {
        query: ({ params }) => ({
          url: apiEndpoints.notifications,
          params,
        }),
      },
    ),
    changeNotificationsView: build.mutation<void, NotificationsSeenRequest>({
      query: (body) => ({
        url: apiEndpoints.notificationsSeen,
        body,
        method: 'POST',
      }),
      invalidatesTags: [GET_NOTIFICATIONS_COUNT],
    }),
  }),
})

export const {
  useNotificationsCountQuery,
  useLazyNotificationsQuery,
  useChangeNotificationsViewMutation,
} = notificationsApi
